import { state } from './mutations';

export default {
  state,
};